import { chain, pick, orderBy } from 'lodash';
import bus from './report-inspector-scene/bus';

const extractCropsFromImage = (scene, image_id) => {
  if (scene.modules) { // TADA: küçük harf ile shelfsight sahneleri gelebiliyor.
    return chain(scene)
      .result('modules', [])
      .map(m => m.shelves)
      .flatten()
      .map(s => s.item_groups)
      .flatten()
      .map(i => i.splits)
      .flatten()
      .map(s => s.items)
      .flatten()
      .filter(crop => crop.image_id === image_id)
      .value();
  }

  if (scene.Modules) {
    return chain(scene)
      .result('Modules', [])
      .map(m => m.shelves)
      .flatten()
      .map(s => s.item_groups)
      .flatten()
      .map(i => i.splits)
      .flatten()
      .map(s => s.items)
      .flatten()
      .filter(crop => crop.image_id === image_id)
      .value();
  }

  if (scene.coolers) {
    return chain(scene)
      .result('coolers', [])
      .map(c => c.Modules).flatten()
      .map(m => m.shelves)
      .flatten()
      .map(s => s.item_groups)
      .flatten()
      .map(i => i.splits)
      .flatten()
      .map(s => s.items)
      .flatten()
      .filter(crop => crop.image_id === image_id)
      .value();
  }

  return chain(scene)
    .result('items', [])
    .flatten()
    .filter(crop => crop.image_id === image_id)
    .value()
    .sort((a, b) => {
      const nextCropSize = ((b.boundaries.bottom_right.x - b.boundaries.top_left.x) * (b.boundaries.bottom_right.y - b.boundaries.top_left.y));
      const currentCropSize = ((a.boundaries.bottom_right.x - a.boundaries.top_left.x) * (a.boundaries.bottom_right.y - a.boundaries.top_left.y));

      return nextCropSize - currentCropSize;
    });
};

export const getSceneData = (VisitSkuValidation, MetaSkuList, CompetitorSkuList) => {
  const normalized_image_sets = [];

  const image_sets = chain(VisitSkuValidation).result('data.image_set_results', []).value();

  image_sets
    .forEach((image_set) => {
      const normalized_image_set = {
        images: [],
        unrecognized_sku_count: 0,
        normal_sku_count: 0,
        meta_sku_count: 0,
        non_sku_count: 0,
        sku_group_id: image_set.sku_group_id,
        task_id: image_set.task_id
      };

      const {
        result, images, category_name, display_type
      } = image_set;
      const {
        image_results, scene = {}, image_set_id, type
      } = result;

      normalized_image_set.display_type = display_type;
      normalized_image_set.category_name = category_name;
      normalized_image_set.image_set_id = images[0].image_set_id;
      normalized_image_set.type = type;

      images.forEach((image) => {
        const {
          id: image_id,
          file_urls: {
            original: url
          },
          position
        } = image;

        let camera_view = image_results.find(image_result => image_result.image_id === image_id);
        camera_view = pick(camera_view, ['global_matrix', 'rectification_matrix']);

        const { global_matrix, rectification_matrix } = camera_view;

        camera_view.global_matrix = global_matrix || '1,0,0,0,1,0,0,0,1';
        camera_view.rectification_matrix = rectification_matrix || '1,0,0,0,1,0,0,0,1';

        const crops = extractCropsFromImage(scene, image_id);

        crops.forEach((acc) => {
          const realogramMisplacedCrop = bus.misplacedList.realogram.find(item => item.crop_id === acc.crop_id);
          const realogramMissingCrop = bus.missingList.realogram.find(item => item.crop_id === acc.crop_id);
          const realogramExcessCrop = bus.excessList.realogram.find(item => item.crop_id === acc.crop_id);
          const realogramOutOfStockCrop = bus.outOfStockList.realogram.find(item => item.crop_id === acc.crop_id);

          const planogramMisplacedCrop = bus.misplacedList.planogram.find(item => item.crop_id === acc.crop_id);
          const planogramMissingCrop = bus.missingList.planogram.find(item => item.crop_id === acc.crop_id);
          const planogramExcessCrop = bus.excessList.planogram.find(item => item.crop_id === acc.crop_id);
          const planogramOutOfStockCrop = bus.outOfStockList.planogram.find(item => item.crop_id === acc.crop_id);

          acc.image_set_id = image_set_id;
          acc.is_meta = !!MetaSkuList.find(sku => sku.id.toString() === acc.class.id);
          acc.is_competitor = !!CompetitorSkuList.find(sku => sku.id.toString() === acc.class.id);
          acc.is_unrecognized = acc.class.type === 'error';
          acc.is_nonSku = acc.class.type !== 'error' && acc.class.type !== 'sku';
          acc.is_sku = acc.class.type === 'sku';

          acc.is_misplacedRealogram = !!(realogramMisplacedCrop && realogramMisplacedCrop.legendState === 'misplaced');
          acc.is_missingRealogram = !!(realogramMissingCrop && realogramMissingCrop.legendState === 'missing');
          acc.is_excessRealogram = !!(realogramExcessCrop && realogramExcessCrop.legendState === 'excess');
          acc.is_out_of_stockRealogram = !!(realogramOutOfStockCrop && realogramOutOfStockCrop.legendState === 'out_of_stock');

          acc.is_misplacedPlanogram = !!(planogramMisplacedCrop && planogramMisplacedCrop.legendState === 'misplaced');
          acc.is_missingPlanogram = !!(planogramMissingCrop && planogramMissingCrop.legendState === 'missing');
          acc.is_excessPlanogram = !!(planogramExcessCrop && planogramExcessCrop.legendState === 'excess');
          acc.is_out_of_stockPlanogram = !!(planogramOutOfStockCrop && planogramOutOfStockCrop.legendState === 'out_of_stock');
        });

        const unrecognized_sku_count = crops.filter(crop => crop.is_unrecognized).length;
        const meta_sku_count = crops.filter(crop => crop.is_meta).length;
        const normal_sku_count = crops.filter(crop => crop.is_sku).length - meta_sku_count;
        const non_sku_count = crops.filter(crop => crop.is_nonSku).length;

        if (position !== undefined) {
          normalized_image_set.images.push({
            crops,
            camera_view,
            url,
            image_id,
            unrecognized_sku_count,
            normal_sku_count,
            meta_sku_count,
            non_sku_count,
            position
          });
        } else {
          normalized_image_set.images.push({
            crops,
            camera_view,
            url,
            image_id,
            unrecognized_sku_count,
            normal_sku_count,
            meta_sku_count,
            non_sku_count
          });
        }

        normalized_image_set.unrecognized_sku_count += unrecognized_sku_count;
        normalized_image_set.meta_sku_count += meta_sku_count;
        normalized_image_set.normal_sku_count += normal_sku_count;
        normalized_image_set.non_sku_count += non_sku_count;
      });

      normalized_image_sets.push(normalized_image_set);
    });

  const sceneData = {
    image_sets: orderBy(normalized_image_sets, ['category_name', 'display_type']),
    unrecognized_sku_count: 0,
    meta_sku_count: 0,
    normal_sku_count: 0,
    non_sku_count: 0,
    visit: pick(VisitSkuValidation.data, ['display_name', 'auditor.name', 'auditor.surname'])
  };

  normalized_image_sets.reduce((acc, item) => {
    acc.unrecognized_sku_count += item.unrecognized_sku_count;
    acc.meta_sku_count += item.meta_sku_count;
    acc.normal_sku_count += item.normal_sku_count;
    acc.non_sku_count += item.non_sku_count;

    return acc;
  }, sceneData);

  return sceneData;
};

export default {
  getSceneData
};
